import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateCourse = props => {
  return (
    <Create
      title='Create Course'
      fields={fields}
      apiPath='admin/courses'
      successRedirectPath={resource => `/events/courses/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateCourse
